import { Component } from '@opten/compiler/metadata/component';
import { CountUp, CountUpOptions } from 'countup.js';

export class CalculatorEnergyLsvaCostSavingsRange{
	minValue: number;
	maxValue: number;
	value: number;
	valueElement: Element;
	inputElement: HTMLInputElement;
}

@Component({
	className: 'js-calculator-energy-lsva-cost-savings',
	observe: true
})
export class CalculatorEnergyLsvaCostSavingsComponent {
	fuelConsumption: number;
	electricityConsumption: number;
	drivingDistance: CalculatorEnergyLsvaCostSavingsRange;
	weight: CalculatorEnergyLsvaCostSavingsRange;
	fuelPrice: CalculatorEnergyLsvaCostSavingsRange;
	electricityPrice: CalculatorEnergyLsvaCostSavingsRange;
	savingsValueElements: NodeListOf<Element>;
	savingsValueElementsCounters: CountUp[] = [];
	currentSavings: number;
	hasEnergyCostCalculatorValues: boolean;
	hasLsvaCalculatorValues: boolean;
	lsvaCategoryElement: HTMLSelectElement;
	lsvaCategoryDefaultValue: number;
	lsvaCategoryPriceElements: NodeListOf<Element>;
	lsvaCategoryDefaultValuePriceElements: NodeListOf<Element>;

	constructor(private element: HTMLElement) {
		this.fuelConsumption = element.hasAttribute('data-fuel-consumption')
			? parseFloat(element.getAttribute('data-fuel-consumption'))
			: null;
		this.electricityConsumption = element.hasAttribute(
			'data-electricity-consumption'
		)
			? parseFloat(element.getAttribute('data-electricity-consumption'))
			: null;
		this.hasLsvaCalculatorValues = element.hasAttribute(
				'data-has-lsva'
			)
				? element.getAttribute('data-has-lsva').toLocaleLowerCase() === 'true'
				: false;
		this.initDrivingDistance();
		this.initSavings();
		if(this.fuelConsumption != null && this.electricityConsumption != null){
			this.initFuelPrice();
			this.initElectricityPrice();
			this.hasEnergyCostCalculatorValues = true;
		}
		if(this.hasLsvaCalculatorValues){
			this.initWeight();
			this.initLsvaCategory();
		}
		this.updateSavingsValue(true);
	}
	
	
	private initSavings() {
		this.savingsValueElements = this.element.querySelectorAll('.js-calculator-energy-lsva-cost-savings-value');
	}
	
	private initLsvaCategory() {
		this.lsvaCategoryElement = this.element.getElementsByClassName('js-calculator-energy-lsva-cost-savings-lsva-category')[0] as HTMLSelectElement;
		this.lsvaCategoryDefaultValue = this.lsvaCategoryElement.hasAttribute('default-value') ? parseFloat(this.lsvaCategoryElement.getAttribute('default-value')): null;
		this.lsvaCategoryPriceElements = this.element.querySelectorAll('.js-calculator-energy-lsva-cost-savings-lsva-category-value');
		this.lsvaCategoryDefaultValuePriceElements = this.element.querySelectorAll('.js-calculator-energy-lsva-cost-savings-lsva-category-default-value');

		this.hasLsvaCalculatorValues = this.lsvaCategoryElement != null && this.lsvaCategoryDefaultValue != null;
		if(this.hasLsvaCalculatorValues){
			this.lsvaCategoryElement.addEventListener('change', () => this.updateSavingsValue())
		}
	}

	private initWeight() {
		const wrapperElement = this.element.querySelector('.js-calculator-energy-lsva-cost-savings-weight');
		this.weight = this.getRange(wrapperElement as HTMLElement);
		if(this.weight != null && this.weight.inputElement != null){
			this.weight.inputElement.addEventListener('input', () => this.handleChangeRange(this.weight, false));
		}	
	}

	private initDrivingDistance() {
		const wrapperElement = this.element.querySelector('.js-calculator-energy-lsva-cost-savings-annual-driving-distance');
		this.drivingDistance = this.getRange(wrapperElement as HTMLElement);
		if(this.drivingDistance != null && this.drivingDistance.inputElement != null){
			this.drivingDistance.inputElement.addEventListener('input', () => this.handleChangeRange(this.drivingDistance, true));
		}	
	}

	private initFuelPrice() {
		const wrapperElement = this.element.querySelector('.js-calculator-energy-lsva-cost-savings-fuel-price');
		this.fuelPrice = this.getRange(wrapperElement as HTMLElement);	
		if(this.fuelPrice != null && this.fuelPrice.inputElement != null){
			this.fuelPrice.inputElement.addEventListener('input', () => this.handleChangeRange(this.fuelPrice,false,true));
		}	
	}

	private initElectricityPrice() {
		const wrapperElement = this.element.querySelector('.js-calculator-energy-lsva-cost-savings-electricity-price');
		this.electricityPrice = this.getRange(wrapperElement as HTMLElement);	
		this.electricityPrice = this.getRange(wrapperElement as HTMLElement);	
		if(this.electricityPrice != null && this.electricityPrice.inputElement != null){
			this.electricityPrice.inputElement.addEventListener('input', () => this.handleChangeRange(this.electricityPrice,false,true));
		}	
	}

	private getRange(wrapperElement: HTMLElement) : CalculatorEnergyLsvaCostSavingsRange{
		var range: CalculatorEnergyLsvaCostSavingsRange = null;
		const inputElement = wrapperElement?.getElementsByClassName('js-calculator-energy-lsva-cost-savings-range')[0] as HTMLInputElement;
		const valueElement = wrapperElement?.getElementsByClassName('js-calculator-energy-lsva-cost-savings-range-value')[0];

		if(inputElement != null && valueElement != null){
			const stepSize = parseFloat(inputElement.step);
			range = {
				minValue: parseFloat(inputElement.min),
				maxValue: parseFloat(inputElement.max),
				value: parseFloat(inputElement.value),
				valueElement: valueElement,
				inputElement: inputElement,
			} as CalculatorEnergyLsvaCostSavingsRange;
		}
		return range;
	}

	private handleChangeRange(range: CalculatorEnergyLsvaCostSavingsRange, formatThousands: boolean = false, isCurrency: boolean = false){
		range.value = parseFloat(range.inputElement.value);
		range.valueElement.innerHTML = this.getNumberFormated(range.value, formatThousands,isCurrency);
		range.inputElement.style.backgroundSize = this.getValueInPercentage(range) + '% 100%';
		this.updateSavingsValue();
	}

	private updateSavingsValue(isInitalLoad: boolean = false){
		if(this.savingsValueElements != null && this.savingsValueElements.length > 0){
		
			if(this.hasEnergyCostCalculatorValues){
				const fuelConsumptionPriceYearly = this.drivingDistance.value * this.fuelPrice.value  * (this.fuelConsumption/100);
				const electricityConsumptionPriceYearly = this.drivingDistance.value * this.electricityPrice.value * (this.electricityConsumption / 100);
				let savingsOneYear = fuelConsumptionPriceYearly - electricityConsumptionPriceYearly;
				if(this.hasLsvaCalculatorValues){
					const lsvaCategoryPrice = parseFloat(this.lsvaCategoryElement.value) * this.weight.value * this.drivingDistance.value;
					savingsOneYear += lsvaCategoryPrice;
				}
				this.currentSavings = savingsOneYear;
				if(isInitalLoad){
					const optionsCounter = {
						startVal: this.currentSavings,
						separator: ' ',
					} as CountUpOptions;
					this.savingsValueElements.forEach(o => {
						var counter = new CountUp(o as HTMLElement, this.currentSavings, optionsCounter);
						this.savingsValueElementsCounters.push(counter);
					});					
				}
				else if(this.savingsValueElementsCounters?.length > 0){
					this.savingsValueElementsCounters.forEach(o => o.update(this.currentSavings));
				}
			}
			else if(this.hasLsvaCalculatorValues){
				const lsvaCategegorySelectedPrice = parseFloat(this.lsvaCategoryElement.value) * this.weight.value * this.drivingDistance.value;
				const lsvaEuroDefaultValuePrice = this.lsvaCategoryDefaultValue * this.weight.value * this.drivingDistance.value;
				const savingsOneYear = lsvaCategegorySelectedPrice - lsvaEuroDefaultValuePrice;
				this.currentSavings = savingsOneYear;
				if(isInitalLoad){
					const optionsCounter = {
						startVal: this.currentSavings,
						separator: ' ',
					} as CountUpOptions;
					this.savingsValueElements.forEach(o => {
						var counter = new CountUp(o as HTMLElement, this.currentSavings, optionsCounter);
						this.savingsValueElementsCounters.push(counter);
					});					
				}
				else{
					if(this.savingsValueElementsCounters?.length > 0){
						this.savingsValueElementsCounters.forEach(o => o.update(this.currentSavings));
					}
					if(this.lsvaCategoryPriceElements?.length > 0){
						const lsvaCategegorySelectedPriceCost = lsvaCategegorySelectedPrice; 
						this.lsvaCategoryPriceElements.forEach(o => o.innerHTML = this.getNumberFormated(lsvaCategegorySelectedPriceCost, true));
					}
					if(this.lsvaCategoryDefaultValuePriceElements?.length > 0){
						const lsvaEuroDefaultValuePriceCost = lsvaEuroDefaultValuePrice; 
						this.lsvaCategoryDefaultValuePriceElements.forEach(o => o.innerHTML = this.getNumberFormated(lsvaEuroDefaultValuePriceCost, true));
					}
				}				
			}
		}
	}

	private getValueInPercentage(range: CalculatorEnergyLsvaCostSavingsRange){
		return (range.value - range.minValue) / (range.maxValue - range.minValue) * 100;
	}

	private getNumberFormated(value: number, formatThousands: boolean = false, isCurrency: boolean = false) : string{
		return formatThousands ? parseInt(value.toString()).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ") : isCurrency ? value.toFixed(2) : value.toFixed(value % 1? value.toString().split(".")[1].length : 0);
	}
}
